module.exports = __webpack_public_path__ + "static/media/bushu-01.88c419bc.png";